import { Control } from "react-hook-form";
import { useEffect, useState } from "react";
import CField from "./CField";

export type Props = {
  required?: boolean;
  control: Control<any, any>;
  error?: any;
  disabled?: boolean;
  name: string;
  country: string;
};

function PostalCode({
  error,
  name,
  disabled = false,
  required = true,
  control,
  country,
  ...props
}: Props) {
  const [postalRegex, setRegex] = useState<RegExp>(/.*/);

  useEffect(() => {
    if (country === "France") {
      setRegex(/^\d{5}$/);
    } else {
      setRegex(/.*/);
    }
  }, [country]);

  return (
    <CField
      label="Code Postal"
      disabled={disabled}
      control={control}
      name={name}
      required={required}
      error={error}
      rules={{
        required: required ? "Veuillez remplir ce champ" : false,
        pattern: {
          value: postalRegex,
          message: "Veuillez saisir un code postal valide",
        },
      }}
      {...props}
    />
  );
}

export default PostalCode;
